<template>
    <!-- 出行支付 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[7, 5]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'travelOne',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-3.png",
            rightBg: "/img/pay/0--67.png",
        }
    },
    computed: {
        title() {
            return this.$t('travel.title');
        },
        subtitle() {
            return this.$t('travelOne.subtitle');
        },
        description() {
            const desc = this.$t('travelOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>